import React, { useState, useCallback } from 'react';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import * as ST from '~/src/components/Main/Info/ProductCard/styled';
import { toCurrency } from '~/src/helpers/numbers';
import { EPriceTypes } from '~/src/models/price';
import { EVENTS } from '~/src/constants/analytics';

const PurchaseBlock = (
    {
        dataTest,
        loading,
        priceOptions,
        orderId,
        orderText,
        selectedOption,
        setLoading,
        setSelectedOption,
        withSelect = true,
    },
) => {
    const [isSelectOpen, setIsSelectOpen] = useState(false);

    const changeOptionsHandler = useCallback(option => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: 'equipment',
            action: option.value > 0 ? `leasing_duration_${option.value}` : 'buy',
            label: null,
        });

        setSelectedOption(option);
        setIsSelectOpen(false);
    }, []);

    const toggleSelectHandler = useCallback(() => {
        if (!isSelectOpen) {
            dataLayerPush({
                event: EVENTS.UAevent,
                category: 'equipment',
                action: 'choose_price',
                label: null,
            });
        }
        setIsSelectOpen(!isSelectOpen);
    }, [isSelectOpen]);

    const onClickOrderHandler = useCallback(event => {
        event.stopPropagation();
        setLoading({ ...loading, isLoadingOrder: true });
    }, [loading]);

    const isDisabledButton = useCallback(() => {
        const { orderStatus, isLoadingOrder } = loading;
        return orderStatus || isLoadingOrder;
    }, [loading]);

    const getCurrency = useCallback(() => {
        if (!selectedOption) {
 return;
}
        return selectedOption.type === EPriceTypes.Possess
            ? ' ₽'
            : ' ₽/мес';
    }, [selectedOption]);

    const getButtonType = useCallback(() => {
        const { orderStatus } = loading;
        return orderStatus ? 'secondary' : 'primary';
    }, [loading]);

    const getButtonText = useCallback(() => {
        const { orderStatus } = loading;
        return !orderStatus ? orderText || 'Заказать' : 'Заказано';
    }, [loading, orderText]);

    const getPriceLabel = useCallback(() => {
        if (!selectedOption) {
 return;
}
        return selectedOption.type === EPriceTypes.Possess
            ? 'покупка'
            : `рассрочка на ${selectedOption.value} мес.`;
    }, [selectedOption]);

    return (
        <ST.PriceBlock>
            <ST.Button
                data-test={dataTest}
                text={getButtonText()}
                type={getButtonType()}
                disabled={isDisabledButton()}
                onClick={onClickOrderHandler}
            />
            <ST.Price data-test='router-item-price'>
                <ST.TextButton>
                    {
                        selectedOption?.pricePromo
                            ? <>
                                <ST.OldPrice>{toCurrency(selectedOption?.price)}{getCurrency()}</ST.OldPrice>
                                {toCurrency(selectedOption.pricePromo)}
                            </>
                            : toCurrency(selectedOption?.price)
                    }
                    {getCurrency()}
                </ST.TextButton>
                {withSelect && selectedOption &&
                <>
                    <ST.Leasing onClick={toggleSelectHandler}>{getPriceLabel()}</ST.Leasing>
                    {isSelectOpen && <>
                        <ST.Select
                            instanceId={`select-price-${orderId}`}
                            options={priceOptions}
                            minWidth='220px'
                            value={selectedOption}
                            onChange={changeOptionsHandler}
                            extStyle={{
                                indicatorsContainer: provided => ({
                                    ...provided,
                                    display: 'none',
                                }),
                                container: provided => ({
                                    ...provided,
                                    position: 'absolute'
                                }),

                                menu: provided => ({
                                    ...provided,
                                    minWidth: '220px',
                                    overflow: 'hidden',
                                    zIndex: 2,
                                }),
                            }}
                            autoFocus
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={false}
                            hideSelectedOptions={false}
                            isClearable={false}
                            menuIsOpen
                            tabSelectsValue={false}
                        />
                        <ST.Blanket onClick={toggleSelectHandler} data-test='router-item-blanket'/>
                    </>
                    }
                </>
                }
            </ST.Price>
        </ST.PriceBlock>
    );
};

export default PurchaseBlock;
